import React, { useState, useEffect } from 'react';

// Variable global fuera del componente para que el evento sobreviva al desmontarse
let globalDeferredPrompt = null;

export default function BotonInstalarPWA() {
  const [mostrarBoton, setMostrarBoton] = useState(!!globalDeferredPrompt);

  useEffect(() => {
    // Si ya se había capturado antes de iniciar sesión, lo mostramos de inmediato
    if (globalDeferredPrompt) {
      setMostrarBoton(true);
    }

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      globalDeferredPrompt = e;
      setMostrarBoton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    window.addEventListener('appinstalled', () => {
      setMostrarBoton(false);
      globalDeferredPrompt = null;
    });

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!globalDeferredPrompt) return;
    
    globalDeferredPrompt.prompt();
    
    const { outcome } = await globalDeferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setMostrarBoton(false);
    }
    globalDeferredPrompt = null;
  };

  if (!mostrarBoton) return null;

  return (
    <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999 }}>
      <button
        onClick={handleInstallClick}
        style={{
          backgroundColor: '#0284c7',
          color: 'white',
          border: 'none',
          padding: '12px 20px',
          borderRadius: '30px',
          fontWeight: 'bold',
          cursor: 'pointer',
          boxShadow: '0 4px 15px rgba(2, 132, 199, 0.4)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '0.9rem',
          transition: 'transform 0.2s'
        }}
      >
        <span>📱</span> Instalar Aplicación 🚀
      </button>
    </div>
  );
}